import { useState, useMemo, useEffect } from 'react';
import { refHandler } from 'app/utils/helper-functions';
import { AddComment } from 'app/components/editor/sidebar/comments/AddComment';
import { AddTag } from 'app/components/editor/sidebar/tags/AddTag';
import { SeletedTextWrapper } from './Paragraph';
import { useEditorSelector, useEditorMode } from 'app/state/contexts/EditorContext';
import { useCoverageScope } from 'app/components/editor/coverage/CoverageScopeContext';
import { v4 as uuidv4 } from 'uuid';

export const ListItemElement = ({ element, attributes, children, withComments, withTags }) => {
  const { isTaggingMode } = useEditorMode();
  const [ref, setRef] = useState(null);
  const [show, setShow] = useState(false);
  const selectionId = useEditorSelector((editor) => editor.selectionId);
  const elementUUID = useMemo(() => element.uuid || uuidv4(), [element.uuid]);
  const anchor = `anchor-${elementUUID}`;
  const listId = `xrp-list-${elementUUID}`;

  const safeAttributesWithId = (attrs) => ({
    ...attrs,
    id: attrs.id || listId,
  });

  useEffect(() => {
    if (!selectionId) {
      setShow(false);
      return;
    }

    setShow(selectionId === element.uuid);
  }, [element.uuid, selectionId]);

  const { scopeUuids, missingUuids } = useCoverageScope();
  let coverageClass = '';
  if (element.uuid) {
    if (missingUuids.has(element.uuid)) coverageClass = ' coverage-missing';
    else if (scopeUuids.has(element.uuid)) coverageClass = ' coverage-scope';
  }

  const liAttrs = safeAttributesWithId(attributes);
  const formattingClass = element.formatting?.class || '';
  return (
    <li {...liAttrs} className={`${formattingClass} ${liAttrs.className ?? ''}${coverageClass}`.trim() || undefined} ref={refHandler(attributes, setRef)}>
      {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
      <a contentEditable="false" href={`#${anchor}`} id={anchor}></a>
      <SeletedTextWrapper popperRef={ref} show={show}>
        <>
          {!!withComments && !isTaggingMode && ref ? <AddComment element={element} /> : null}
          {withTags && isTaggingMode && ref ? <AddTag element={element} /> : null}
        </>
      </SeletedTextWrapper>
      {children}
    </li>
  );
};
